import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { Email } from '../../model/email';
import { EmailService } from '../../service/data/email.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { dateTimeString } from '../../../core/helper/date-time';

@Component({
    selector: 'app-email-form',
    templateUrl: './email-form.component.html',
    styleUrls: ['./email-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmailFormComponent extends FormComponentBase<Email> {
  constructor(
    commandDispatcher: CommandDispatcher,
    private _emailService: EmailService,
    private _fb: FormBuilder,
    private _fc: FormControlExFactory,
    private _nativeWindow: NativeWindowService,
    activatedRoute: ActivatedRoute,
    handlerResolver: StandardCommandHandlerResolver,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(activatedRoute, _emailService, messageService, navigation, commandDispatcher, handlerResolver);
  }

  protected createModel(): Email {
    return new Email();
  }

  savedAttachments: FormArray;

  maxNewAttachments: number;

  protected prepareSave(): Email {
    const result = super.prepareSave();
    result.savedAttachments = this.savedAttachments.controls.map(f => f.value);
    return result;
  }

  downloadAttachment(attachmentId: string) {
    this.AddSubscription(
      this._emailService.downloadAttachment(attachmentId).subscribe(res => {
        var result = new File([res], decodeURIComponent(res.name.replace(/\+/g, ' ')));
        this._nativeWindow.save(result);
      })
    );
  }

  protected getFormGroup(): FormGroup {
    this.savedAttachments = this.dataContext.savedAttachments
      ? this._fb.array(
          this.dataContext.savedAttachments.map(att =>
            this._fb.group({
              id: this._fc.createHidden(att.id),
              originalName: this._fc.createHidden(att.originalName),
              size: this._fc.createHidden(att.size),
            })
          )
        )
      : this._fb.array([]);

    return this._fb.group({
      statusCaption: this._fc.createReadonly('COMMON.STATUS', this.dataContext.statusCaption),
      createdDateTime: this._fc.createReadonly('COMMON.CREATED_DATE', dateTimeString(this.dataContext.createdDateTime)),
      sentDateTime: this._fc.createReadonly('COMMON.SENT', dateTimeString(this.dataContext.deliveredDateTime)),
      emailaddress: this._fc.createReadonly('COMMON.RECEIVER', this.dataContext.recipientEmailAddress),
      subject: this._fc.createReadonly('MAIL_FORM.SUBJECT', this.dataContext.subject),
      body: this._fc.createReadonly('MAIL_FORM.BODY_LABEL', this.dataContext.body),
      savedAttachments: this.savedAttachments,
    });
  }
}
